<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/menu"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Ubah Menu
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Nama Menu" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Nama Menu
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              outlined
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Pejabat"

                              hide-details

                              v-model="form.title"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.title !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6">
                          <div class="body-2 mb-2">

                            Parent (Menu Diatasnya)
                          </div>

                          <v-autocomplete
                            v-on:keyup.enter="save()"

                            outlined
                            rounded
                            dense

                            :color="set_color"
                            placeholder="Pilih salah satu bila ingin membuat sub menu"

                            hide-details
                            clearable

                            :items="parent"
                            item-text="title"
                            item-value="id"
                            :item-color="set_color"

                            v-model="form.parent"
                            style="border-radius: 10px;">
                          </v-autocomplete>
                        </v-col>
                        <!-- <v-col
                          cols="12"
                          v-if="form.parent === '' || form.parent === null"
                          md="6">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>

                            Tipe Menu
                          </div>
                          <v-select
                            v-on:keyup.enter="save()"

                            outlined
                            rounded
                            dense

                            :color="set_color"
                            placeholder="Pilih salah satu"

                            hide-details
                            clearable

                            :items="[
                              { text: 'Tidak Ada Sub Menu', value: 'page' },
                              { text: 'Ada Sub Menu', value: 'url' }
                            ]"
                            item-text="text"
                            item-value="value"
                            :item-color="set_color"

                            v-model="form.type"
                            style="border-radius: 10px;">
                          </v-select>
                        </v-col> -->
                        <v-col cols="12">
                          <quill-editor
                            v-on:keyup.enter="save()"
                            v-model="form.content"
                            :options="{
                              theme: 'snow',
                              placeholder: 'Tulis isi menu disini...'
                            }">
                          </quill-editor>
                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                elevation="0"
                color="green"
                class="fs-16 white--text text-capitalize border-radius">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                to="/menu"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {

        form: {
          title: '',
          parent: '',
          content: '',
          type: '',
          parent_name: '',
          id: this.$route.params.id,
          unit_id: ''
        },
        parent: [],

        process: {
          form: false,

          image: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      'form.parent' (val) {
        if (val !== null) {
          let parent = this.parent.find(x => x.id === val)
          this.form.parent_name = parent.title
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        let params = {
          limit: 1000000000000000,
          id: this.$route.params.id
        }

        await get(`admin/menu_page/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.form = res.results.data[0]
            this.form.parent = this.form.parent_id
            this.form.unit_id = this.user.unit_id
            this.fetchParent()
          }
        })
      },
      async fetchParent () {
        let params = {
          limit: 100000000000,
          parent_id: 0,
          unit_id: this.user.unit_id
        }

        await get(`admin/menu_page/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.parent = res.results.data
            this.form.parent_name = this.form.parent_id === '0' ? '' : this.parent.find(x => x.id === this.form.parent_id).title
          }
        })
      },
      async save () {
        this.message.error = ''
        this.form.parent = this.form.parent === null ? '' : this.form.parent

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/menu_page/update`, {
            data: {
              id: this.form.id,
              title: this.form.title,
              parent_id: this.form.parent === '' ? '0' : this.form.parent,
              url: this.form.parent === "0" ? this.form.title.split(' ').join('-').toLowerCase() : this.form.parent_name.split(' ').join('-').toLowerCase() + '-' + this.form.title.split(' ').join('-').toLowerCase(),
              type: this.form.content === '' || this.form.content === null || this.form.content.length < 1 ? 'url' : 'page',
              is_active: 1,
              content: this.form.content,
              unit_id: this.form.unit_id
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/menu' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>